module.exports = __webpack_public_path__ + "img/insurance-bg.3da273fc.png";